import { useStorage } from 'vue3-storage';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Api from '@/classes/Api.ts';

const $storage = useStorage();

class Broadcast
{
    private $echo: Echo<'reverb'> | null = null;

    private $Api: Api;

    constructor($Api: Api) {
        this.$Api = $Api;
    }

    public getEcho(): Echo<'reverb'> {
        if (this.$echo !== null) {
            return this.$echo;
        }

        const token = $storage.getStorageSync('token') || localStorage.getItem('access_token');

        window.Pusher = Pusher;
        this.$echo = new Echo({
            broadcaster: 'reverb',
            key: this.$Api.getEnv('VITE_APP_REVERB_APP_KEY'),
            // wsHost: this.$Api.getEnv('VITE_REVERB_HOST'),
            wsHost: this.$Api.getEnv('VITE_APP_BACKEND_HOST'),
            // wsPort: this.$Api.getEnv('VITE_REVERB_PORT') ?? 80,
            wsPort: 80,
            // wssPort: this.$Api.getEnv('VITE_REVERB_PORT') ?? 443,
            // forceTLS: (this.$Api.getEnv('VITE_REVERB_SCHEME') ?? 'https') === 'https',
            forceTLS: false,
            enabledTransports: ['ws'],
            authEndpoint: this.$Api.getApiPrefixNew() + '/broadcasting/auth',
            auth: {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            },
        });

        return this.$echo;
    }
}

export default Broadcast;
